export default {
	dice: {
		chosenDice: null,
		showDialog: false,
		highestBet: 0,
	},
	suit: {
		chosenSuit: '',
		showDialog: false,
		showChosenSuit: false,
		bgposition: 0,
	},
	chosenSuit: {
		showDialog: false,
		value: '',
	},
	clock: {
		value: 20,
		turnDuration: 0,
		playerCount: 0,

		roomURL: '',
		showCheatVote: false,
	},
	score: {
		roundsToWin: 0,
		ourRounds: 0, // round I won or my team won
		opponentRounds: 0, // round my opponent won or the other team won
		//
		ourPoints: 0,
		opponentPoints: 0,
	},

	// foundGame: true,
	ingame: false,

	myIndex: null,

	redirect: '',

	currentPlayer: null,

	topPlayer: {
		cards: [],
		clock: false,
		chosenCard: { show: null, suit: null, card: null },
	},
	rightPlayer: {
		cards: [],
		clock: false,
		chosenCard: { show: null, suit: null, card: null },
	},
	leftPlayer: {
		cards: [],
		clock: false,
		chosenCard: { show: null, suit: null, card: null },
	},
	hand: {
		cards: [],
		clock: false,
		chosenCard: { show: null, suit: null, card: null },
		handActive: 0,
	},
};
